var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      ref: "addToWishList",
      staticClass: "btn pl-0",
      staticStyle: { width: "unset" },
      attrs: { "data-placement": "top" },
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.switchState()
        }
      }
    },
    [
      _c("icon", {
        staticClass: "default-float",
        class: { "text-appearance text-danger": _vm.isVariationInWishList },
        attrs: { icon: "heart", loading: _vm.isLoading }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }